export default __webpack_public_path__ + "d9fe2dc9e7c9b3d7edfba82af5e9af41.png";